import Vue from 'vue'
import VueRouter from 'vue-router'
import { auth } from '@/shared/firebase'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      scanExpectations: ['productId', 'shelfSpace', 'ean']
    },
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/query',
    name: 'query',
    component: () => import('@/views/Query.vue')
  },
  {
    path: '/arrival',
    name: 'arrival',
    component: () => import('@/views/Arrival.vue')
  },
  {
    path: '/pick/:orderId?',
    name: 'pick',
    component: () => import('@/views/Pick.vue')
  },
  {
    path: '/purchase',
    name: 'purchase',
    component: () => import('@/views/Purchase.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !auth.currentUser) next('login')
  else {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  }
})

export default router
